import { createSlice } from "@reduxjs/toolkit";

export const commentSlice = createSlice({
  name: "newComment",
  initialState: {
    newComment: "",
  },
  reducers: {
    setNewComment: (state, action) => {
      state.newComment = action.payload;
    },
  },
});

export const { setNewComment } = commentSlice.actions;


export default commentSlice.reducer;
